import React, { useRef, useState, useEffect, useCallback } from "react";
import Logo from "../images/logo.svg";
import Sidebar from '../component/Sidebar';
import { Avatar, SelectPicker, DatePicker, Drawer, Placeholder, Whisper, Button, Popover, Stack, Message, useToaster, Tooltip, Input, Loader, Modal, Uploader, Progress, } from "rsuite";
import { encryptData, decryptData } from "./cryptoUtil";
import { ChakraProvider, useToast, Wrap } from "@chakra-ui/react";
import debounce from "lodash.debounce";
import "aos/dist/aos.css";
import AOS from "aos";

const Dashboard = () => {

const [tabName, setTabName] = useState('User Logs');

  useEffect(() => {
    document.title = tabName;
  }, [tabName]);

    const toast = useToast();
    const toastIdRef = React.useRef();
  const userid = sessionStorage.getItem("userId");
  const isAdmin = sessionStorage.getItem("isAdmin");

  const abortControllerRef = useRef(null);
    const [isLoading, setLoading] = useState(false); // State to manage loading state
    const [globalLoading, setGlobalLoading] = useState(true); // State to manage loading state
    const abortControllerRefGlobal = useRef(null);
    const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
    const [pageRange, setPageRange] = useState("20");
    const [reportdata, setReportData] = useState([]);
    const [reportCount, setReportCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchInput, setSearchInput] = useState("");
    const [orderBy, setOrderBy] = useState("id"); // default orderBy
    const [order, setOrder] = useState("DESC"); // default order
 const [customPaginationValue, setCustomPaginationValue] = useState("");

  const fetchGlobalReport = async () => {
  
      setGlobalLoading(true);
  
      // Cancel the previous request if any
      if (abortControllerRefGlobal.current) {
        abortControllerRefGlobal.current.abort();
      }
  
      const controller = new AbortController();
      abortControllerRefGlobal.current = controller;
  
  
 
  
      try {
      
  
        const apiUrl = `${apiEndPoint}/user_login_history`;
        const requestData = encryptData({
          data: {
            user_id: userid,
            limit: pageRange,
            page: currentPage.toString(),
            q: searchInput || "",
            order: order,
            orderBy: orderBy,
            analyst: "",
          },
        });
  
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: requestData,
          signal: controller.signal,
        });
  
        const jsonData = await response.json();
        const decrypted = decryptData(jsonData);

        if (decrypted.data.status == "success") {
          setGlobalLoading(false);
          setReportCount(decrypted.data.count);
          setReportData(decrypted.data.history);
        } else {
          setGlobalLoading(false);
          setReportCount(decrypted.data.count);
          setReportData(decrypted.data.history);
          //toastIdRef.current = toast({ description: decrypted.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
          return false;
        }
      } catch (error) {
        if (error.name === "AbortError") {
          console.log("GLobal Request cancelled");
        } else {
          setGlobalLoading(false);
          toastIdRef.current = toast({ description: error.message, status: "error", duration: 5000, isClosable: true, position: "bottom", });
        }
        return false;
      }
    };

    const debouncedFetchGlobalReport = useCallback(
        debounce(() => {
          fetchGlobalReport();
        }, 1000),
        [searchInput] // Only debounce on search input changes
      );
    
      useEffect(() => {
        debouncedFetchGlobalReport();
        return () => {
          debouncedFetchGlobalReport.cancel();
        };
      }, [searchInput]);


useEffect(() => {
  fetchGlobalReport();
}, []);

  useEffect(() => {
    fetchGlobalReport();
  }, [currentPage, pageRange]);

    const handlePagelimit = (value) => {
    setCurrentPage(1);
    setCustomPaginationValue(1);
    setPageRange(value);
  };

    const debouncedSetPage = useCallback(
      debounce((page) => {
        setCurrentPage(page);
      }, 1000), // Delay of 500ms (half a second)
      []
    );
  

    const handlePaginationChange = (e) => {
    const value = (e.target.value == 0 ? 1 : e.target.value).toString();
    setCustomPaginationValue(value); // Update input value immediately for fast typing
    debouncedSetPage(Number(value)); // Trigger the debounced function
  };


     const renderPagination = () => {
    // Calculate total number of pages
    const totalPages = Math.ceil(reportCount / pageRange);

    // Show a default of 3 pages if the total pages are more than 3
    const pageNumbers = [];
    const visiblePageCount = 4; // Number of pages to show by default

    let startPage = currentPage - 1;
    let endPage = currentPage + 2;

    // Adjust pagination if total pages are less than the default
    if (totalPages <= visiblePageCount) {
      startPage = 1;
      endPage = totalPages;
    } else {
      // Ensure the pagination does not go out of bounds
      startPage = Math.max(1, startPage);
      endPage = Math.min(totalPages, endPage);
    }

    // Create page numbers to display based on current page
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <nav
        aria-label="..."
        id="pagination_row"
        style={{
          alignItems: "center",
          justifyContent: "space-between",
          background: "#FFF",
          paddingTop: 0,
          paddingBottom: 0,
          zIndex: 3,
          marginBottom: 10,
        }}
      >
        <div className="totalRecords">
          Total Records : {Number(reportCount).toLocaleString()}
        </div>
        <ul className="pagination" style={{ border: 0, background: "none" }}>
          <li class="page-item" style={{ marginLeft: 10 }}>
            <SelectPicker
              onChange={handlePagelimit}
              cleanable={false}
              value={pageRange}
              placement="top"
              placeholder="Pages"
              data={PagingData}
              searchable={false}
              style={{
                width: 85,
                height: 35,
                display: "flex",
                alignItems: "center",
                borderRadius: 5,
                border: "1px solid #A1B9ED",
              }}
            />
          </li>

          {/* Previous Page (Double Arrow) */}
          <li
            className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
            style={{ marginLeft: 10 }}
          >
            <a href="#" className="page-link" onClick={() => setCurrentPage(1)}>
              <i className="fa fa-angle-double-left"></i>
            </a>
          </li>

          {/* Previous Page (Single Arrow) */}
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <a
              href="#"
              className="page-link"
              onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
            >
              <i className="fa fa-angle-left"></i>
            </a>
          </li>

          {/* Page numbers */}
          {pageNumbers.map((page) => (
            <li
              key={page}
              className={`page-item ${currentPage === page ? "active" : ""}`}
            >
              <a
                className="page-link"
                href="#"
                onClick={() => setCurrentPage(page)} // Set the clicked page as the current page
              >
                {page}
              </a>
            </li>
          ))}

          {/* Next Page (Single Arrow) */}
          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
          >
            <a
              href="#"
              className="page-link"
              onClick={() =>
                setCurrentPage(Math.min(totalPages, currentPage + 1))
              }
            >
              <i className="fa fa-angle-right"></i>
            </a>
          </li>

          {/* Next Page (Double Arrow) */}
          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
            style={{ marginRight: 10 }}
          >
            <a
              href="#"
              className="page-link"
              onClick={() => setCurrentPage(totalPages)}
            >
              <i className="fa fa-angle-double-right"></i>
            </a>
          </li>

          {/* Go to Page */}
          <li
            className="page-item"
            style={{
              marginLeft: 10,
              display: "flex",
              alignItems: "center",
              gap: 5,
            }}
          >
            <input
              type="text"
              placeholder="Go#"
              className="form-control"
              value={customPaginationValue}
              onChange={handlePaginationChange}
              onInput={(e) => {
                // Only allow numbers
                e.target.value = e.target.value.replace(/[^0-9]/g, "");
              }}
              style={{
                padding: "0px 10px",
                color: "#878787",
                fontSize: 16,
                borderRadius: 5,
                border: "1px solid #A1B9ED",
                width: 60,
                height: 35,
                textAlign: "center",
              }}
            />
          </li>
        </ul>
      </nav>
    );
  };
  
    // PAGINATION
    const PagingData = ["10", "20", "50", "100"].map((item) => ({
      label: item,
      value: item,
    }));

     const handleSearch = (event) => {


    setSearchInput(event.target.value);
    setCurrentPage(1); // Reset to the first page for new search
  };


 useEffect(() => {
    AOS.init();
  }, []);
  
    return (
        <>
            <Sidebar />
             <ChakraProvider resetCSS={false}>
                    {" "}
                    <Wrap> </Wrap>{" "}
                  </ChakraProvider>
            <div id='header'>
                <div className='logo'>
                    <div className='logo_icon'>
                        <img src={Logo} alt="Logo" />
                    </div>
                    <div className='brand_name'>Logs</div>
                </div>

                <div className='header_table_filter'>
                    <div className='searchfield'>
                        <button className='btn_search'><i className='icon-search2'></i></button>
                        <input
                            type='text'
                            className='filter_searchfield'
                            placeholder='Search'
                            onChange={handleSearch}
                            value={searchInput}
                        />
                    </div>

                    <a
                        href="#"
                        className="btn_clear_filter"
                        style={{ textDecoration: "none" }}
                    >
                        Clear Filters
                    </a>
                </div>
            </div>



 <div className="container-fluid content pb-5">
    <div className="company_table_list" data-aos="fade-up" data-aos-duration="800" >
 {globalLoading && ( <Placeholder.Grid rows={20} columns={9} active style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }} /> )}

       
          {!globalLoading && (
            <>
          
              <div className='table-responsive clsPagingWrap'>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Login</th>
                                <th>Logout</th>
                                <th>Total Active</th>
                                <th>Browser</th>
                                <th>IP</th>
                                <th>OS</th>
                                <th>Country</th>
                                <th>Location</th>
                            </tr>
                        </thead>
                       <tbody>
                           {reportdata && reportdata.length === 0 ? (
                              <tr>
                        <td colSpan="14" style={{ textAlign: "center", fontSize: 20, paddingTop: 60, paddingBottom: 30, }} >
                          No data available
                        </td>
                      </tr>
                       ) : (
                          reportdata &&
                      reportdata.map((item, index) => (
                        <>
  <tr>
    <td style={{ fontWeight: 600, fontSize: 16, color: '#2D2D2D' }}>
       <div style={{ cursor: "pointer" }} className="name__col_cell" >
             <div className="img_name_profile">
                <img src={item.profile_img} alt="User" />
              </div>
        <span>{item.fullname}</span>
      </div>
    </td>
    <td style={{ fontWeight: 600, fontSize: 14, color: '#4D4D4D' }}>
      {item.login_time}
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
     {item.logout_time}
    </td>
      <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
     {item.total_active_time}
    </td>
     <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
     {item.browser}
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
     {item.ip_address}
    </td>
    <td style={{ fontWeight: 600, fontSize: 16, color: '#2D2D2D' }}>
      {item.os}
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
    {item.country}
    </td>
    <td style={{ fontWeight: 500, fontSize: 14, color: '#4D4D4D' }}>
     {item.location}
    </td>
  </tr>
  </>
 ))
                    )}
                      </tbody>

                    </table>
                </div>
           {reportCount > 1 && renderPagination()}
             </>
          )}
           </div>
      </div>  
        </>
    );
};

export default Dashboard;
